export function createBarChartCustomTooltip(isOrganizationGraph, organizationGraphChartColors, chartColors, dataLabels, i18n) {
  //We need a higher order function here because chartjs injects a this value
  return function (tooltipModel) {
    let colorsLegend = isOrganizationGraph ? organizationGraphChartColors : chartColors;

    // Tooltip Element
    let oldTooltipEl = document.getElementById('chartjs-tooltip');
    if (oldTooltipEl) {
      document.body.removeChild(oldTooltipEl);
    }
    let svgSmaller = `<svg xmlns="http://www.w3.org/2000/svg" width="292" height="100" viewBox="0 0 292 100" fill="none">
                            <g filter="url(#filter0_d_1891_117981)">
                            <path d="M4 8C4 3.58172 7.58172 0 12 0H280C284.418 0 288 3.58172 288 8V68C288 72.4183 284.418 76 280 76H159.819C157.105 76 154.577 77.3757 153.102 79.6542L145.989 90.6476C145.586 91.2703 144.67 91.2532 144.29 90.6159L137.917 79.9082C136.475 77.4849 133.863 76 131.043 76H12C7.58172 76 4 72.4183 4 68V8Z" fill="white"/>
                            </g>
                            <defs>
                            <filter id="filter0_d_1891_117981" x="0" y="0" width="292" height="99.1045" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1891_117981"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1891_117981" result="shape"/>
                            </filter>
                            </defs>
                            </svg>`;
    let svgMedium = `<svg xmlns="http://www.w3.org/2000/svg" width="292" height="120" viewBox="0 0 292 120" fill="none">
                            <g filter="url(#filter0_d_1891_117992)">
                            <path d="M4 8C4 3.58172 7.58172 0 12 0H280C284.418 0 288 3.58172 288 8V88C288 92.4183 284.418 96 280 96H159.793C157.094 96 154.576 97.3614 153.098 99.6205L145.882 110.652C145.476 111.272 144.559 111.25 144.183 110.611L137.91 99.9446C136.473 97.5007 133.85 96 131.015 96H12C7.58172 96 4 92.4183 4 88V8Z" fill="white"/>
                            </g>
                            <defs>
                            <filter id="filter0_d_1891_117992" x="0" y="0" width="292" height="119.104" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1891_117992"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1891_117992" result="shape"/>
                            </filter>
                            </defs>
                            </svg>`;
    function getBody(bodyItem) {
      return bodyItem.lines;
    }

    // Set Text
    if (!tooltipModel.body) {
      return;
    }
    let titleLines = tooltipModel.title || [];
    let bodyLines = tooltipModel.body.map(getBody);
    let tooltipEl = document.createElement('div');
    tooltipEl.id = 'chartjs-tooltip';
    tooltipEl.innerHTML = '<div style=" margin-top: 10px;"></div>';
    tooltipEl.style.filter = 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.10));';
    document.body.appendChild(tooltipEl);
    let colors = tooltipModel.labelColors[0];
    let legendIndex = colorsLegend.indexOf(colors.backgroundColor);
    let parser = new DOMParser();
    let doc;
    let isSmall;
    if (dataLabels[legendIndex]?.length < 25) {
      doc = parser.parseFromString(svgSmaller, "image/svg+xml");
      isSmall = true;
    } else {
      doc = parser.parseFromString(svgMedium, "image/svg+xml");
      isSmall = false;
    }
    let innerHtml = `<div style="display: flex; flex-direction: column; justify-content: ${isSmall ? 'flex-start' : 'center'}; gap: ${isSmall ? '' : '15px'}; height: ${isSmall ? '100' : '120'}px">`;
    tooltipEl.appendChild(doc.documentElement);

    // Set caret Position
    tooltipEl.classList.remove('above', 'below', 'no-transform');
    if (tooltipModel.yAlign) {
      tooltipEl.classList.add(tooltipModel.yAlign);
    } else {
      tooltipEl.classList.add('no-transform');
    }
    titleLines.forEach(function (title) {
      innerHtml += `<p style="margin-bottom: 2px; margin-top: 15px; color: #545E75">${title}</p>`;
    });
    bodyLines.forEach(function (body, i) {
      innerHtml += `<div style="height: 20px; width: 280px; height: 40px; display: flex; gap: 17px; justify-content: center; align-items: center; padding: 0px 16px 0px 0px">
                                        <div style="width:60%; display: flex; align-items: center">                
                                            <div style='width: 16px; height: 16px; margin-right: 5px; background-color: ${colors.backgroundColor};'></div>
                                            <p style="font-family: Inter; font-size: 14px; font-style: normal; font-weight: 400; line-height: 20px; letter-spacing: -0.1px; color: #072448; margin: 0px 10px 0px 0px">
                                            ${dataLabels && dataLabels[legendIndex] ? i18n`${dataLabels[legendIndex]}` : ""}
                                            </p>
                                        </div>     
                                        <p style="color: #072448; margin-right: 10px; font-family: Inter; font-size: 14px; font-style: normal; font-weight: 600; line-height: 20px; letter-spacing: -0.1px; margin: 0px 4px 0px 0px">${body}</p>
                                    </div>`;
    });
    innerHtml += '</div>';
    let tableRoot = tooltipEl.querySelector('div');
    tableRoot.innerHTML = innerHtml;

    // `this` will be the overall tooltip
    let position = this._chart.canvas.getBoundingClientRect();
    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.left = position.left + window.scrollX + tooltipModel.caretX - 150 + 'px';
    tooltipEl.style.top = position.top + window.scrollY + tooltipModel.caretY - 80 + 'px';
    ;
    tooltipEl.style.fontFamily = 'Inter';
    tooltipEl.style.fontSize = '12px';
    tooltipEl.style.fontStyle = 'normal';
    tooltipEl.style.fontWeight = '400';
    tooltipEl.style.lineHeight = '16px';
    tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.width = '292px';
    tooltipEl.style.height = isSmall ? '100px' : '120px';
    tooltipEl.style.zIndex = '1';
    let svg_tooltip = tooltipEl.querySelector('svg');
    svg_tooltip.style.zIndex = '1';
    svg_tooltip.style.position = 'relative';
    svg_tooltip.style.top = '-100px';
    tableRoot.style.marginLeft = '10px';
    tableRoot.style.position = 'relative';
    tableRoot.style.zIndex = '3';
  };
}